import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon';
import DefaultButton from 'components/Utils/NewDefaultButton';
import ProgressMessage from 'components/Utils/ProgressMessage';
import './style.scss';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';

const CreditCardImage = (props) => {
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);
  const [showOptions, setShowOptions] = useState(false);

  function onClick() {
    if (props.showButtons && !props.preventClick) {
      setShowOptions(true);
    }
  }

  async function makeCreditCardDefault(event) {
    event.stopPropagation();
    event.preventDefault();
    if (!props.preventClick) {
      setLoading(true);
      await dispatch(
        api.Payments.makeCreditCardDefault({
          patientId: props.patient.id,
          cardId: props.card.id,
        }),
        { errorTitle: 'Credit Card' },
      );
      setLoading(false);
      props.onChange();
    }
  }

  async function deleteCreditCard(event) {
    event.stopPropagation();
    event.preventDefault();
    setLoading(true);
    await dispatch(
      api.Payments.deleteCreditCard({
        patientId: props.patient.id,
        cardId: props.card.id,
      }),
      { errorTitle: 'Credit Card' },
    );
    setLoading(false);
    props.onChange();
  }

  let { card } = props;

  if (!card) return null;

  let className = 'credit-card-image';
  if (!props.preventClick) className += ' clickable';

  let brand = card?.brand?.toLowerCase();
  if (brand === 'american express') brand = 'amex';

  return (
    <div className={className}>
      <div className="contents" onClick={onClick}>
        <div className="column">
          <Icon src={['fab', `cc-${brand}`]} width="70px" className="brand" alt={card?.brand} />
          <div className="number">
            <span>****</span>
            <span>****</span>
            <span>****</span>
            <span className="last-4">{card.last4}</span>
          </div>
        </div>
        <div className="expiry">
          <span>
            Expires on {card.exp_month}/{card.exp_year}
          </span>
          {card.is_default && (
            <div className="default">
              <Icon src="circle-check" className="green" width="20px" />
              <span>Active</span>
            </div>
          )}
        </div>
      </div>

      {loading && (
        <div className="loading rounded">
          <ProgressMessage size={60} />
        </div>
      )}

      {props.showButtons && !loading && showOptions && (
        <div
          className="hover-buttons rounded"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            setShowOptions(false);
          }}
        >
          <DefaultButton
            id="card-make-default"
            name="Make Default"
            hide={card.is_default}
            style={{ width: '250px' }}
            onClick={makeCreditCardDefault}
          />
          <DefaultButton
            name="Remove Card"
            id="card-remove"
            style={{ width: '250px' }}
            className="red"
            onClick={deleteCreditCard}
          />
        </div>
      )}
    </div>
  );
};

CreditCardImage.propTypes = {
  patient: PropTypes.object.isRequired,
  card: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  showButtons: PropTypes.bool,
  preventClick: PropTypes.bool,
};

export default CreditCardImage;
